import styled from "styled-components";

export const ContentBigNumber = styled.div`
    display: flex;
    flex-direction: column;
    padding: 16px;
    gap: 16px;
    border-radius: 8px;
    border: 1px solid #CDCACA80;
    min-width: 260px;
      flex: 1;

    p{
        font-size: 14px;
    }

    span{
        font-size: 40px;
        color: #5863F8;
        text-align: center;
    }
`